/* eslint-disable no-param-reassign */
import { LoadingStyle } from "components/Loading/loading.style";
import * as _ from "lodash";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { GEO_MODEL } from "utils/models";
import Button from "../../../components/Button/button.component";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import MapGeo from "../../../components/Map/map.component";
import Title from "../../../components/Title/title.component";
import { LAGOA_DOS_PATOS, LAGOA_MIRIM } from "../../../constants";
import GeoService from "../../../services/geoService";
import ArrayHelper from "../../../utils/arrayHelper";
import ToastHelper from "../../../utils/toastHelper";

class CadastroGeo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mapKey: 0,
			isDirty: false,
			geo: GEO_MODEL,
			loading: false
		};
		this.setAreaDesenhada = this.setAreaDesenhada.bind(this);
		this.setMunicipios = this.setMunicipios.bind(this);
		this.updateStateAfterGetIntersection = this.updateStateAfterGetIntersection.bind(
			this
		);
	}

	async componentDidMount() {
		const {
			props: { alertaId },
			state: { mapKey }
		} = this;

		this.setLoading(true);
		const responseAlerta = await GeoService.findGeoByAlertaId(
			alertaId,
			() => {
				this.setState({ mapKey: mapKey + 1 });
			}
		);

		this.setState({
			mapKey: mapKey + 1,
			geo: {
				...responseAlerta
			},
			loading: false
		});
	}

	componentWillUnmount() {
		const { geo } = this.state;
		this.handleSubmit(geo);
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	handleSubmit = async () => {
		const { isDirty } = this.state;
		if (isDirty) {
			const {
				state: { geo },
				props: { alertaId }
			} = this;
			this.setLoading(true);
			await GeoService.saveGeo(this.createModel(geo), async () => {
				await GeoService.findGeoByAlertaId(alertaId);
				this.setLoading(false);
			});
			ToastHelper.success("Municípios foram salvos com sucesso!");
		}
	};

	handleCancelar = () => {
		this.setState({ isOpenDialogCancelar: true, isDirty: false });
	};

	handleDialogCancelar = ({ isOpenDialogCancelar }, { history }) => (
		<WidgetDialog
			title="Atenção!"
			isOpen={isOpenDialogCancelar}
			textCancelar="Não"
			textConfirmar="Sim"
			mensagem="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos"
			cancelar={() => {
				this.setState({ isOpenDialogCancelar: false });
			}}
			confirmar={() => {
				this.setState({ isOpenDialogCancelar: false });
				history.push("/alertas");
			}}
		/>
	);

	createModel = geoObject => {
		const objectToBeSaved = _.cloneDeep(geoObject);

		objectToBeSaved.municipios = ArrayHelper.getUnique(
			objectToBeSaved.municipios,
			"codigoIbge"
		);

		_.remove(objectToBeSaved.municipios, m => {
			delete m.geom;
			delete m.localizacao;

			return (
				m.codigoIbge === LAGOA_DOS_PATOS || m.codigoIbge === LAGOA_MIRIM
			);
		});

		if (_.isEmpty(objectToBeSaved.areaDesenhada)) {
			delete objectToBeSaved.areaDesenhada;
		}

		if (typeof objectToBeSaved.areaDesenhada === "string") {
			objectToBeSaved.areaDesenhada = JSON.parse(
				objectToBeSaved.areaDesenhada
			);
		}

		return objectToBeSaved;
	};

	setAreaDesenhada = geometryCollection => {
		this.setState(prevState => ({
			geo: {
				...prevState.geo,
				areaDesenhada: geometryCollection
			}
		}));
	};

	setMunicipios = municipiosMapAdded => {
		const { geo } = this.state;
		this.setState({
			geo: {
				...geo,
				municipios: municipiosMapAdded
			}
		});
	};

	updateStateAfterGetIntersection(data, alertaId) {
		const { geo } = this.state;
		this.setState(prevState => ({
			isDirty: true,
			geo: {
				...geo,
				alertaId,
				municipios: [...prevState.geo.municipios, ...data.municipios],
				areaDesenhada: data.areaDesenhada
			}
		}));
	}

	render = () => {
		const { alertaId, onClick } = this.props;
		const { geo, mapKey } = this.state;
		return (
			<React.Fragment>
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}

				<Title>Georreferenciamento dos municípios afetados</Title>
				<hr />
				<div className="text-center card">
					<MapGeo
						alertaId={alertaId}
						GeoService={GeoService}
						geoCadastrados={geo}
						key={mapKey}
						setAreaDesenhada={this.setAreaDesenhada}
						setMunicipios={this.setMunicipios}
						updateStateAfterGetIntersection={
							this.updateStateAfterGetIntersection
						}
					/>
				</div>
				<div className="row mt-3">
					<div className="col-6">
						<div className="row">
							<div className="col-md-12">
								<div className="float-left ">
									<Button
										onClick={() => onClick("dados")}
										type="submit"
										primary
										text="Voltar"
										icon="fas fa-arrow-left"
									/>
									<Button
										cancel
										type="button"
										text="Cancelar"
										icon="fas fa-times"
										onClick={() => this.handleCancelar()}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className="col-6">
						<div className="row">
							<div className="col-md-12">
								<div className="float-right">
									<Button
										type="submit"
										onClick={() => this.handleSubmit()}
										primary
										text="Salvar"
										icon="fas fa-save"
									/>
									<Button
										onClick={() => onClick("analise")}
										primary
										type="button"
										text="Próximo"
										icon="fas fa-arrow-right"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.handleDialogCancelar(this.state, this.props)}
			</React.Fragment>
		);
	};
}

export default withRouter(CadastroGeo);
